import script from "./PlanLockOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanLockOverlay.vue?vue&type=script&setup=true&lang=js"

import "./PlanLockOverlay.vue?vue&type=style&index=0&id=ef05d6ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef05d6ba"]])

export default __exports__